import React from 'react';
import './Logo.scss';
import BlankWidget from '../../components/CategoryListing/Widgets/BlankWidgets';
const MainHeaderLogo = props => {
  const {
    appLogo,
    dataLocale: { LENSKART },
  } = props;
  return (
    <div className="logo">
      {appLogo ? (
        <>
          <a href="/">
            <img alt={LENSKART} src={appLogo} title={LENSKART} />
          </a>
        </>
      ) : (
        <div className="blank-logo">
          <BlankWidget rowsArray={['1']} styleObj="" />
        </div>
      )}
    </div>
  );
};

export default MainHeaderLogo;
